<header class="app-nav">

  <nav class="navbar navbar-expand-lg navbar-dark bg-dark blue">
    <div class="container">
          <a class="navbar-brand logo" routerLink="/">
            <img [src]='logoImage'>
          </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                <li class="nav-item active">
                  <a routerLink="/"  class="nav-link waves-light btn-border-rev" mdbWavesEffect>
        <!--            <mdb-icon fas icon="home"></mdb-icon> -->
                    STRONA GŁÓWNA<span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item active">
                  <a routerLink="/my-projects" class="nav-link waves-light btn-border-rev" mdbWavesEffect>
        <!--            <mdb-icon fas icon="images"></mdb-icon> -->
                    MOJE PROJEKTY</a>
                </li>
                <li class="nav-item active">
                  <a routerLink="/help" class="nav-link waves-light btn-border-rev" mdbWavesEffect>
        <!--            <mdb-icon fas icon="info"></mdb-icon>-->
                    POMOC</a>
                </li>
      </ul>

    </div>
    </div>
  </nav>

<!--  -->
<!--  &lt;!&ndash;Navbar&ndash;&gt;-->
<!--  <mdb-navbar SideClass="navbar navbar-expand-lg navbar-dark blue" [containerInside]="true">-->

<!--    &lt;!&ndash; Navbar brand &ndash;&gt;-->
<!--    <mdb-navbar-brand>-->
<!--      <a class="navbar-brand logo" routerLink="/">-->
<!--        <img [src]='logoImage'>-->
<!--      </a>-->
<!--    </mdb-navbar-brand>-->

<!--    &lt;!&ndash; Collapsible content &ndash;&gt;-->
<!--    <links>-->
<!--      &lt;!&ndash; Links &ndash;&gt;-->
<!--      <ul class="navbar-nav ml-auto">-->
<!--        <li class="nav-item active">-->
<!--          <a routerLink="/"  class="nav-link waves-light btn-border-rev" mdbWavesEffect>-->
<!--&lt;!&ndash;            <mdb-icon fas icon="home"></mdb-icon> &ndash;&gt;-->
<!--            STRONA GŁÓWNA<span class="sr-only">(current)</span></a>-->
<!--        </li>-->
<!--        <li class="nav-item active">-->
<!--          <a routerLink="/my-projects" class="nav-link waves-light btn-border-rev" mdbWavesEffect>-->
<!--&lt;!&ndash;            <mdb-icon fas icon="images"></mdb-icon> &ndash;&gt;-->
<!--            MOJE PROJEKTY</a>-->
<!--        </li>-->
<!--        <li class="nav-item active">-->
<!--          <a routerLink="/help" class="nav-link waves-light btn-border-rev" mdbWavesEffect>-->
<!--&lt;!&ndash;            <mdb-icon fas icon="info"></mdb-icon>&ndash;&gt;-->
<!--            POMOC</a>-->
<!--        </li>-->
<!--      </ul>-->
<!--      &lt;!&ndash; Links &ndash;&gt;-->
<!--    </links>-->
<!--    &lt;!&ndash; Collapsible content &ndash;&gt;-->
<!--  </mdb-navbar>-->
<!--  &lt;!&ndash;/.Navbar&ndash;&gt;-->
</header>


